module.exports = __webpack_public_path__ + "img/pleasure-icon-6.26c3491c.svg";